(() => {
  const init = () => {
    const definitions = [
      { panel: document.querySelector('.block_account_canvas'), triggers: '.account_canvas .myaccount', close: '.close_account' },
      { panel: document.querySelector('.block_cart_canvas #_desktop_cart'), triggers: '.cart_canvas .header-cart', close: '.close_cart' }
    ];
    definitions.forEach(({ panel, triggers, close }) => {
      if (!panel) return;
      let wasOpen = false;
      let previousFocus;
      const synchronize = () => {
        const isOpen = panel.classList.contains('active');
        panel.setAttribute('aria-hidden', String(!isOpen));
        document.querySelectorAll(triggers).forEach(button => button.setAttribute('aria-expanded', String(isOpen)));
        if (isOpen && !wasOpen) {
          previousFocus = document.activeElement;
          panel.querySelector(close)?.focus();
        } else if (!isOpen && wasOpen && previousFocus?.isConnected) previousFocus.focus();
        wasOpen = isOpen;
      };
      new MutationObserver(synchronize).observe(panel, { attributes: true, attributeFilter: ['class'] });
      synchronize();
      panel.addEventListener('keydown', event => {
        if (!panel.classList.contains('active')) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          panel.querySelector(close)?.click();
        } else if (event.key === 'Tab') {
          const controls = [...panel.querySelectorAll('a[href], button, input, select, summary')].filter(el => !el.disabled && el.getClientRects().length);
          if (!controls.length) return;
          const first = controls[0], last = controls[controls.length - 1];
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        }
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
